/**
 * Created by mh on 2017/5/24.
 */
import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { withRouter, NavLink } from 'react-router-dom';

import { MdSettingsInputAntenna } from 'react-icons/md';

@withRouter @inject('auth') @observer
class NavigationLeft extends Component {
    render() {
        return (
            <nav className="col-sm-3 col-md-2 d-none d-sm-block bg-light sidebar">
                <ul className="nav nav-pills flex-column">
                    <li className="nav-item">
                        <NavLink
                            className="nav-link"
                            activeClassName="active"
                            exact
                            to="/channels/">
                            <MdSettingsInputAntenna />
                            <FormattedMessage id="Channels.Channels" defaultMessage="Channels" />
                        </NavLink>
                    </li>
                </ul>
            </nav>
        );
    }
}

NavigationLeft.propTypes = {
};

export default injectIntl(NavigationLeft);
